export const FOLDERS = {
  PT_DEMOGRAPHICS: 'Patient Demographics',
  PERSONAL_DATA: 'Personal Data',
  HEALTH_DATA: 'Health Data',
  MEDICAL_RECORDS: 'Medical records',
  INSURANCE_CARD: 'Insurance Card',
  ID_CARD: 'ID Card',
  AUDIO_FILES: 'Audio Files',
  FEEDBACKS: 'Feedbacks',
  RADIOLOGY_IMAGES: 'Radiology images',
  PRESCRIPTIONS: 'Prescriptions',
  REFERRALS: 'Referrals',
  CONSULTATION_NOTES: 'Consultation notes',
  VACCINATION: 'Vaccination'
};
